// extracted by mini-css-extract-plugin
export default {"wrapper":"Input_wrapper__vG66U","input":"Input_input__5mQdH"};